<template>
  <v-cardbody v-show="isActive">
    <slot />
  </v-cardbody>
</template>

<script>
import CardBody from "@/atoms/CardBody";
export default {
  components: {
    "v-cardbody": CardBody
  },
  props: {
    name: { required: true },
    selected: { default: false}
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    this.isActive = this.selected;
  }
};
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
</style>
